import React, { FC } from 'react';
import { DeleteIcon, EditIcon } from 'components/common/icons';
import { PERMISSIONS } from 'constants/permissions';
import { Button, Col, Row, Typography } from 'components';
import { HasAccess } from 'components/common/accessControl';
import { SpecialPricingRulesAddUpdateModal } from './../addEdit';
import { useSpecialPricingRule } from './useSpecialPricingRule';
import styles from './styles.module.scss';

const { Text } = Typography;

interface ISpecialPricingRule {
  data: Record<string, any>;
  onHandleDelete: (i: { id: string | undefined }) => void;
}

export const SpecialPricingRule: FC<ISpecialPricingRule> = React.memo((props) => {
  const { data, onHandleDelete } = props;
  const { minLeadTime, maxLeadTime, type, discount, markup, brand, brandId } = data;
  const { editModalState, onEditModalStateChange } = useSpecialPricingRule();
  return (
    <>
      <Row gutter={[0, 12]} className={styles.special_pricing_rule}>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'} gutter={[16, 0]} wrap={false}>
            <Col span={18}>
              <Text style={{ fontWeight: 600 }} type={'secondary'} title={brand?.name} className={styles.name}>
                {brand?.name} {brandId}
              </Text>
            </Col>
            <Col>
              <HasAccess role={PERMISSIONS.suppliers.special_pricing_rules.delete}>
                <Button
                  size={'small'}
                  type={'text'}
                  onClick={() => onHandleDelete({ id: data.id })}
                  icon={<DeleteIcon />}
                />
              </HasAccess>
              <HasAccess role={PERMISSIONS.suppliers.special_pricing_rules.write}>
                <Button size={'small'} type={'text'} onClick={onEditModalStateChange} icon={<EditIcon />} />
              </HasAccess>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <Row justify={'space-between'}>
                <Col>
                  <Text type={'secondary'}>Margin</Text>
                </Col>
                <Col>
                  <Text type={'secondary'}>{markup ? `${markup}%` : 'Not Set'}</Text>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify={'space-between'}>
                <Col>
                  <Text type={'secondary'}>Discount</Text>
                </Col>
                <Col>
                  <Text type={'secondary'}>{discount ? `${discount}%` : 'Not Set'}</Text>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify={'space-between'}>
                <Col>
                  <Text type={'secondary'}>Lead Time</Text>
                </Col>
                <Col>
                  <Text type={'secondary'}>
                    {minLeadTime && maxLeadTime
                      ? `${minLeadTime}-${maxLeadTime} ${type === 'DAY' ? 'days' : 'weeks'}`
                      : minLeadTime
                        ? `${minLeadTime} Min`
                        : maxLeadTime
                          ? `${maxLeadTime} Max`
                          : 'Not Set'}
                  </Text>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <SpecialPricingRulesAddUpdateModal
        modalState={editModalState}
        onModalStateChange={onEditModalStateChange}
        dataToEdit={data}
      />
    </>
  );
});
